import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isNumber } from '@/utils';
export default {
  name: 'goods_drawer',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleId: [Number, String],
    prepend: {
      type: String,
      default: '点'
    } //单位
  },
  computed: {
    Styles: function Styles() {
      var _this$value$config$co = this.value.config.content_padding_top,
        content_padding_top = _this$value$config$co === void 0 ? 30 : _this$value$config$co;
      var baseSize = 32; //基准值 16*2 C端即可直接取值
      var contentPaddingTop = content_padding_top / baseSize;
      return {
        '--contentPaddingTop': contentPaddingTop + 'rem'
      };
    },
    bannerList: function bannerList() {
      var _this$value$config$ba, _this$value$config$ba2;
      return ((_this$value$config$ba = this.value.config.banner) === null || _this$value$config$ba === void 0 ? void 0 : (_this$value$config$ba2 = _this$value$config$ba.map(function (i) {
        return i.imageurl;
      })) === null || _this$value$config$ba2 === void 0 ? void 0 : _this$value$config$ba2.filter(function (i) {
        return Boolean(i);
      })) || [];
    },
    //  根据展示行数 & 展示列数 显示数据
    goodsList: function goodsList() {
      var _this = this;
      if (!isNumber(this.value.config.rows) || !isNumber(this.value.config.cols)) {
        return [this.value.default_value];
      }
      return new Array(Number(this.value.config.rows)).fill().map(function (_, index) {
        return _this.value.default_value.slice(index * _this.value.config.cols, (index + 1) * _this.value.config.cols);
      }).filter(function (i) {
        return i.length > 0;
      });
    }
  }
};